import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading streamer profile..." @subtitle="Getting streamer details, schedule, and content" />
</template>
);
